import { LISTA_PERMISSOES } from '../util/listaPermissoes'

export const rotasSautec = [
    {
        path: "/sde/usuarioautorizacoes",
        name: 'UsuarioAutorizacoes',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/pdr/usuarioautorizacoes/usuarioautorizacoesListagem'),
    },
    // INTERNAÇÃO
    {
        path: "/sde/leitos/mapa",
        name: 'mapaLeitos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/leitos/mapaLeitos')
    },
    {
        path: "/sde/internacao/fila",
        name: 'filaInternacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacaosolicitacao/filaInternacao')
    },
    {
        path: "/sde/internacao",
        name: 'internacaoListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacao/internacaoListagem')
    },
    {
        path: "/sde/internacao/:id",
        name: 'fichaInternacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacao/fichaInternacao')
    },
    {
        path: "/sde/internacao/medicacao/:id",
        name: 'internacaoMedicacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacao/formMedicacaoAplicacao')
    },
    {
        path: "/sde/internacao/exames/:id",
        name: 'internacaoExames',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacao/formExameExecucao')
    },
    {
        path: "/sde/internacao/sinaisvitais/:id",
        name: 'internacaoSinaisVitais',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacao/formSinaisVitaisInternacao')
    },
    {
        path: "/sde/internacao/evolucao/:id",
        name: 'internacaoEvolucao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacao/formEvolucaoInternacao')
    },
    {
        path: "/sde/internacaoadm",
        name: 'internacaoadm',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/internacaoadm/internacaoAdmListagem')
    },
    {
        path: "/sde/internacaoadm/:id",
        name: 'internacaoadmEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/internacaoadm/internacaoAdmEditar')
    },
    {
        path: "/sde/internacaosituacao",
        name: 'internacaosituacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacaosituacao/internacaosituacaoListagem')
    },
    {
        path: "/sde/internacaosituacao/:id",
        name: 'internacaosituacaoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/internacaosituacao/internacaosituacaoEditar')
    },
    {
        path: "/sde/aih",
        name: 'aihListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/aih/aihListagem')
    },
    {
        path: "/sde/aih/:id",
        name: 'aihEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/aih/aihEditar')
    },
    {
        path: "/sde/leitotipo",
        name: 'leitotipo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/leitos/leitotipoListagem')
    },
    {
        path: "/sde/leitotipo/:id",
        name: 'leitotipoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/leitos/leitotipoEditar')
    },
    {
        path: "/sde/leito",
        name: 'leito',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/leitos/leitoListagem')
    },
    {
        path: "/sde/leito/:id",
        name: 'leitoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/leitos/leitoEditar')
    },

    // CADASTROS (gerais/transversais)
    {
        path: "/sde/pessoas",
        name: 'CadPessoas',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/gen/pessoas/pessoasListagem')
    },
    {
        path: "/sde/pessoas/:id",
        name: 'pessoasEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/gen/pessoas/pessoasEditar')
    },
    {
        path: "/sde/minhaempresa",
        name: 'MinhaEmpresa',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/gen/minhaempresa/minhaEmpresaEditar')
    },
    {
        path: "/sde/parametros",
        name: 'parametros',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/parametrosSistema')
    },
    {
        path: "/sde/municipios",
        name: 'Municipios',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/gen/municipios/municipiosListagem')
    },
    {
        path: "/sde/municipios/:id",
        name: 'MunicipiosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/gen/municipios/municipiosEditar')
    },
    {
        path: "/sde/bairros",
        name: 'Bairros',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/gen/bairros/bairrosListagem')
    },
    {
        path: "/sde/bairros/:id",
        name: 'BairrosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/gen/bairros/bairrosEditar')
    },

    // ATENDIMENTOS
    {
        path: "/sde/pacientes",
        name: 'CadPacientes',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/pacientes/pacientesListagem')
    },
    {
        path: "/sde/pacientes/:id",
        name: 'pacientesEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/pacientes/pacientesEditar')
    },
    {
        path: "/sde/convenios",
        name: 'CadConvenios',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/convenios/conveniosListagem')
    },
    {
        path: "/sde/convenios/:id",
        name: 'conveniosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/convenios/conveniosEditar')
    },
    {
        path: "/sde/sigtap",
        name: 'SigtapConsulta',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/sus/sigtapConsulta')
    },
    {
        path: "/sde/procedimentos",
        name: 'CadProcedimentos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/procedimentos/procedimentosListagem')
    },
    {
        path: "/sde/procedimentos/:id",
        name: 'procedimentosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/procedimentos/procedimentosEditar')
    },
    {
        path: "/sde/exames",
        name: 'CadExames',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/exames/examesListagem')
    },
    {
        path: "/sde/exames/:id",
        name: 'examesEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/exames/examesEditar')
    },
    {
        path: "/sde/contahospitalar",
        name: 'contaHospitalarListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/contahospitalar/contaHospitalarListagem')
    },
    {
        // conta aberta (virtual) do episódio — tipo = atendimento | internacao
        path: "/sde/contahospitalar/episodio/:tipo/:id",
        name: 'contaEpisodio',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/contahospitalar/contaEpisodio')
    },
    {
        path: "/sde/contahospitalar/:id",
        name: 'contaHospitalarEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/contahospitalar/contaHospitalarEditar')
    },
    {
        path: "/sde/faturamento",
        name: 'contaFaturamentoListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/contahospitalar/contaFaturamentoListagem')
    },
    {
        path: "/sde/faturamento/:id",
        name: 'contaFaturamentoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/contahospitalar/contaFaturamento')
    },
    {
        path: "/sde/faturamentoconvenio",
        name: 'faturamentoConvenioListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/contahospitalar/faturamentoConvenioListagem')
    },
    {
        path: "/sde/faturamentoconvenio/:id",
        name: 'faturamentoConvenioEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/contahospitalar/faturamentoConvenio')
    },
    {
        path: "/sde/profissionalremuneracaofechamento",
        name: 'fechamentoRemuneracaoListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/profissionalremuneracaofechamento/ProfissionalRemuneracaoFechamentoListagem')
    },
    {
        path: "/sde/profissionalremuneracaofechamento/:id",
        name: 'fechamentoRemuneracaoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/profissionalremuneracaofechamento/ProfissionalRemuneracaoFechamentoEditar')
    },
    {
        path: "/sde/consultatipo",
        name: 'consultatipo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/consultatipo/consultatipoListagem')
    },
    {
        path: "/sde/consultatipo/:id",
        name: 'consultatipoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/consultatipo/consultatipoEditar')
    },
    {
        path: "/sde/agendamento",
        name: 'agendamento',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/agendamento/agendamentoListagem')
    },
    {
        path: "/sde/atendimentomedico",
        name: 'atendimentomedico',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        // empresa com SDE_APS abre o atendimento APS (SOAP); as demais, o atendimento médico
        component: () => import('@/views/sde/atendimento/atendimentoMedicoRota')
    },
    {
        path: "/sde/atendimentotriagem",
        name: 'atendimentotriagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/atendimento/atendimentoTriagem')
    },
    {
        path: "/sde/atendimentoadm",
        name: 'atendimentoadm',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/atendimentoadm/atendimentoAdmListagem')
    },
    {
        path: "/sde/atendimentoadm/:id",
        name: 'atendimentoadmEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/atendimentoadm/atendimentoAdmEditar')
    },
    {
        path: "/sde/regras-producao",
        name: 'RegrasProducao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/regrasProducao')
    },
    {
        path: "/sde/producao-sus",
        name: 'ProducaoSus',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/producaoSus')
    },
    {
        path: "/sde/aih-sus",
        name: 'AihSus',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/aihSus')
    },
    // ATENÇÃO BÁSICA (módulo SDE_APS)
    {
        path: "/sde/territorio",
        name: 'Territorio',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/aps/territorioListagem')
    },
    {
        path: "/sde/aps/cronicos",
        name: 'HipertensosDiabeticos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/aps/hipertensosDiabeticos')
    },
    {
        path: "/sde/aps/retornos",
        name: 'RetornosAgendar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/aps/retornosAgendar')
    },
    {
        path: "/sde/farmacia/vencimentos",
        name: 'MedicamentosVencer',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/farmacia/medicamentosVencer')
    },
    {
        path: "/sde/aps/prenatal",
        name: 'Prenatal',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/aps/prenatalListagem')
    },
    {
        path: "/sde/territorio/mapa",
        name: 'MapaTerritorio',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/aps/mapaTerritorio')
    },
    {
        path: "/sde/territorio/domicilio/:id",
        name: 'DomicilioEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/aps/domicilioEditar')
    },
    {
        // Visitas do ACS: relatório cruzado + mapa (obrigatório 5) e atalho para o app /acs/
        path: "/sde/aps/acs",
        name: 'VisitasAcs',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/aps/visitasAcs')
    },
    {
        // * tela demonstrativa (dados fictícios) — PLANO_GESTAO_MUNICIPAL
        path: "/sde/aps/esus",
        name: 'ApsEsusDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/demo/apsEsusDemo')
    },
    {
        path: "/sde/aps/indicadores",
        name: 'IndicadoresAps',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/aps/indicadoresAps')
    },
    {
        path: "/sde/vacina/sala",
        name: 'SalaVacina',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/vacina/salaVacina')
    },
    {
        // Conferência das doses lançadas pelo ACS com foto da carteira (obrigatório 3)
        path: "/sde/vacina/conferencia-acs",
        name: 'ConferenciaAcs',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/vacina/conferenciaAcs')
    },
    {
        path: "/sde/vacina/busca-ativa",
        name: 'BuscaAtivaVacina',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/vacina/buscaAtivaVacina')
    },
    {
        // Regulação (módulo SDE_REGULACAO)
        path: "/sde/regulacao/fila",
        name: 'CentralRegulacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/regulacao/centralRegulacao')
    },
    {
        path: "/sde/regulacao/ppi",
        name: 'CotasRegulacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/regulacao/cotasRegulacao')
    },
    {
        path: "/sde/regulacao/prestadores",
        name: 'PrestadoresListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/regulacao/prestadoresListagem')
    },
    {
        path: "/sde/regulacao/prestadores/:id",
        name: 'PrestadorEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/regulacao/prestadorEditar')
    },
    {
        path: "/sde/regulacao/tfd",
        name: 'TransporteViagens',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/transporte/transporteViagens')
    },
    {
        path: "/sde/transporte/veiculos",
        name: 'VeiculosListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/transporte/veiculosListagem')
    },
    {
        path: "/sde/transporte/veiculos/:id",
        name: 'VeiculoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/transporte/veiculoEditar')
    },
    {
        path: "/sde/transporte/motoristas",
        name: 'MotoristasListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/transporte/motoristasListagem')
    },
    {
        path: "/sde/transporte/frota",
        name: 'FrotaControle',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/transporte/frotaControle')
    },
    {
        path: "/sde/transporte/motoristas/:id",
        name: 'MotoristaEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/transporte/motoristaEditar')
    },
    {
        // Vigilância (módulo SDE_VIGILANCIA)
        path: "/sde/vigilancia/epidemiologica",
        name: 'VigilanciaEpidemiologica',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/vigilancia/vigilanciaEpidemiologica')
    },
    {
        path: "/sde/vigilancia/mdda",
        name: 'Mdda',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/vigilancia/mddaRelatorio')
    },
    {
        // * tela demonstrativa (dados fictícios) — PLANO_GESTAO_MUNICIPAL
        path: "/sde/vigilancia/sanitaria",
        name: 'VigSanitariaDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/demo/vigilanciaSanitariaDemo')
    },
    {
        // * telas demonstrativas — laboratório (uma rota por aba, mesmo componente) — PLANO_GESTAO_MUNICIPAL
        path: "/sde/laboratorio",
        name: 'LaboratorioDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/demo/laboratorioDemo')
    },
    {
        path: "/sde/laboratorio/coleta",
        name: 'LaboratorioColetaDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/demo/laboratorioDemo')
    },
    {
        path: "/sde/laboratorio/mapas",
        name: 'LaboratorioMapasDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/demo/laboratorioDemo')
    },
    {
        path: "/sde/laboratorio/resultados",
        name: 'LaboratorioResultadosDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/demo/laboratorioDemo')
    },
    {
        path: "/sde/laboratorio/equipamentos",
        name: 'LaboratorioEquipamentosDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/demo/laboratorioDemo')
    },
    {
        path: "/sde/laboratorio/soroteca",
        name: 'LaboratorioSorotecaDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/demo/laboratorioDemo')
    },
    {
        // Tabelas de preço e TUSS (módulo SDE_CONVENIOS; PLANO_SAUDE_PARTICULAR.md 1.4)
        path: "/sde/tabelapreco",
        name: 'TabelasPrecoListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/tabelapreco/tabelasPrecoListagem')
    },
    {
        path: "/sde/tabelapreco/:id",
        name: 'TabelaPrecoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/tabelapreco/tabelaPrecoEditar')
    },
    {
        path: "/sde/tuss",
        name: 'TerminologiaTuss',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/tabelapreco/terminologiaTuss')
    },
    {
        // Faturamento ambulatorial em lote (módulo SDE_CONVENIOS; PLANO_SAUDE_PARTICULAR.md 3.4)
        path: "/sde/faturamentoambulatorial",
        name: 'FaturamentoAmbulatorial',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/guiatiss/faturamentoAmbulatorial')
    },
    {
        // Glosas e recursos de glosa (módulo SDE_CONVENIOS; PLANO_SAUDE_PARTICULAR.md 3.3)
        path: "/sde/glosastiss",
        name: 'GlosasTiss',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/lotetiss/glosasTiss')
    },
    {
        // Lotes TISS: XML para a operadora (módulo SDE_CONVENIOS; PLANO_SAUDE_PARTICULAR.md 3.2)
        path: "/sde/lotestiss",
        name: 'LotesTiss',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/lotetiss/lotesTiss')
    },
    {
        path: "/sde/lotestiss/:id",
        name: 'LoteTiss',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/lotetiss/loteTiss')
    },
    {
        // Guias TISS (módulo SDE_CONVENIOS; PLANO_SAUDE_PARTICULAR.md 3.1)
        path: "/sde/guiastiss",
        name: 'GuiasTiss',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/guiatiss/guiasTiss')
    },
    {
        path: "/sde/guiastiss/:id",
        name: 'GuiaTiss',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/guiatiss/guiaTiss')
    },
    {
        // Autorizações (senhas) do plano (módulo SDE_CONVENIOS; PLANO_SAUDE_PARTICULAR.md 1.3)
        path: "/sde/autorizacoes",
        name: 'AutorizacoesPlano',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/autorizacao/autorizacoesPlano')
    },
    {
        // Patrimônio (módulo SDE_GESTAO; obrigatório 14)
        path: "/sde/patrimonio/bens",
        name: 'BensPatrimonioListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/patrimonio/bensPatrimonioListagem')
    },
    {
        path: "/sde/patrimonio/bens/:id",
        name: 'BemPatrimonioEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/patrimonio/bemPatrimonioEditar')
    },
    {
        path: "/sde/patrimonio/grupos",
        name: 'GruposPatrimonioListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/patrimonio/gruposPatrimonioListagem')
    },
    {
        path: "/sde/patrimonio/grupos/:id",
        name: 'GrupoPatrimonioEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/patrimonio/grupoPatrimonioEditar')
    },
    {
        // Gestão Municipal (módulo SDE_GESTAO)
        path: "/sde/gestao/painel",
        name: 'PainelGestor',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/gestao/painelGestor')
    },
    {
        // Comunicação com o cidadão (obrigatórios 8–11)
        path: "/sde/gestao/comunicacao",
        name: 'ComunicacaoCidadao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/gestao/comunicacaoCidadao')
    },
    {
        // Pesquisa de satisfação (obrigatórios 26–28)
        path: "/sde/gestao/satisfacao",
        name: 'SatisfacaoPainel',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/gestao/satisfacaoPainel')
    },
    {
        // App do cidadão — gestão: acessos, horários do app, alterações de cadastro (obrigatórios 17–21 e 25)
        path: "/sde/gestao/app-cidadao",
        name: 'AppCidadaoGestao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/gestao/appCidadaoGestao')
    },
    {
        path: "/sde/aih-autorizacao",
        name: 'AihAutorizacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/aihAutorizacao')
    },
    {
        // APAC — laudo, autorização com faixa, validade/continuidade (Fase 8 do plano SUS)
        path: "/sde/apac",
        name: 'ApacListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/sus/apac/apacListagem')
    },
    {
        path: "/sde/apac/:id",
        name: 'ApacEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/sus/apac/apacEditar')
    },
    {
        // RAAS de atenção psicossocial — CAPS (Fase 8 do plano SUS)
        path: "/sde/raas",
        name: 'RaasListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/sus/raas/raasListagem')
    },
    {
        path: "/sde/raas/:id",
        name: 'RaasEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/sus/raas/raasEditar')
    },
    {
        // * tela demonstrativa (sem funcionalidade), para apresentação comercial — será reformulada
        path: "/sde/rnds",
        name: 'RndsDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/demo/rndsDemo')
    },
    {
        // * tela demonstrativa (sem funcionalidade), para apresentação comercial — será reformulada
        path: "/sde/bnafar",
        name: 'BnafarDemo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/demo/bnafarDemo')
    },
    {
        path: "/sde/estabelecimento-sus",
        name: 'EstabelecimentoSus',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/estabelecimentoSus')
    },
    {
        path: "/sde/cnes",
        name: 'CnesImportacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/cnesImportacao')
    },
    {
        path: "/sde/equipes",
        name: 'equipes',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/equipeListagem')
    },
    {
        path: "/sde/equipes/:id",
        name: 'equipeEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN],
        },
        component: () => import('@/views/sde/sus/equipeEditar')
    },
    {
        path: "/sde/profissionais",
        name: 'profissionais',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/profissionais/profissionaisListagem')
    },
    {
        path: "/sde/profissionais/:id",
        name: 'profissionaisEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/profissionais/profissionaisEditar')
    },
    {
        path: "/sde/pontoatendimento",
        name: 'pontoatendimento',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/pontoatendimento/pontoatendimentoListagem')
    },
    {
        path: "/sde/pontoatendimento/:id",
        name: 'pontoatendimentoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/pontoatendimento/pontoatendimentoEditar')
    },
    {
        path: "/sde/atendimentosobdemanda",
        name: 'atendimentoSobDemanda',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_MEDICO],
        },
        component: () => import('@/views/sde/atendimento/atendimentoSobDemanda')
    },
    {
        path: "/sde/escalaplantao",
        name: 'escalaPlantao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/escalaplantao/EscalaPlantao')
    },
    {
        path: "/sde/escalaplantaoturno",
        name: 'escalaplantaoturno',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/escalaplantaoturno/escalaplantaoturnoListagem')
    },
    {
        path: "/sde/escalaplantaoturno/:id",
        name: 'escalaplantaoturnoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO],
        },
        component: () => import('@/views/sde/escalaplantaoturno/escalaplantaoturnoEditar')
    },

    // FARMÁCIA
    {
        path: "/sde/medicamentos",
        name: 'medicamentos',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO],
        },
        component: () => import('@/views/sde/medicamentos/MedicamentosListagem')
    },
    {
        path: "/sde/medicamentos/:id",
        name: 'medicamentosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO],
        },
        component: () => import('@/views/sde/medicamentos/MedicamentosEditar')
    },
    {
        path: "/sde/medicamentoformafarmaceutica",
        name: 'medicamentoformafarmaceutica',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO],
        },
        component: () => import('@/views/sde/medicamentoformafarmaceutica/medicamentoformafarmaceuticaListagem')
    },
    {
        path: "/sde/medicamentoformafarmaceutica/:id",
        name: 'medicamentoformafarmaceuticaEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO],
        },
        component: () => import('@/views/sde/medicamentoformafarmaceutica/medicamentoformafarmaceuticaEditar')
    },
    {
        // Fornecedor é gen.Pessoa (isfornecedor=true), compartilhado com o
        // financeiro (mesma tela de /fin/fornecedores) — registrado aqui de novo
        // porque o router troca todo o conjunto de rotas por sistema (ver
        // routesManager.js). A tela monta as rotas pelo prefixo do sistema logado.
        path: '/sde/fornecedores',
        name: 'fornecedoresSautec',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/fin/fornecedor/FornecedorListagem')
    },
    {
        path: "/sde/fornecedores/:id",
        name: 'fornecedoresSautecEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/fin/fornecedor/FornecedorEditar')
    },
    {
        // NF-e de entrada compartilhada com o financeiro: na saúde os itens entram no
        // estoque como medicamento/material (ver NfeentradaEditar, isSaude).
        path: '/sde/nfeentrada',
        name: 'nfeentradaSautec',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/fin/nfeentrada/NfeentradaListagem')
    },
    {
        path: "/sde/nfeentrada/:id",
        name: 'nfeentradaSautecEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/fin/nfeentrada/NfeentradaEditar')
    },
    {
        path: "/sde/nfeentrada/devolucao/:id",
        name: 'nfeentradaSautecDevolucao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/fin/nfeentradadevolucao/NfeentradaDevolucao')
    },
    {
        path: "/sde/nfeentradadevolucao",
        name: 'nfeentradaSautecDevolucaoListagem',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/fin/nfeentradadevolucao/NfeentradaDevolucaoListagem')
    },
    {
        path: "/sde/estoque/dispensacao",
        name: 'estoqueDispensacao',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO],
        },
        component: () => import('@/views/sde/estoque/estoqueDispensacao')
    },

    // ALMOXARIFADO
    {
        path: "/sde/material",
        name: 'material',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/material/materialListagem')
    },
    {
        path: "/sde/material/:id",
        name: 'materialEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/material/materialEditar')
    },
    {
        path: "/sde/estoque/saida-material",
        name: 'estoqueSaidaMaterial',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/estoque/estoqueSaidaMaterial')
    },

    // COMPARTILHADO (Farmácia + Almoxarifado — telas genéricas de estoque, servem medicamento e material)
    {
        path: "/sde/deposito",
        name: 'deposito',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/deposito/depositoListagem')
    },
    {
        path: "/sde/deposito/:id",
        name: 'depositoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/deposito/depositoEditar')
    },
    {
        path: "/sde/estoqueminimo",
        name: 'estoqueminimo',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/estoqueminimo/estoqueminimoListagem')
    },
    {
        path: "/sde/estoqueminimo/:id",
        name: 'estoqueminimoEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/estoqueminimo/estoqueminimoEditar')
    },
    {
        path: "/sde/estoque/transferencia",
        name: 'estoqueTransferencia',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/estoque/estoqueTransferencia')
    },
    {
        path: "/sde/estoque/entrada",
        name: 'estoqueEntrada',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/estoque/estoqueEntrada')
    },
    {
        path: "/sde/estoque/posicao",
        name: 'posicaoEstoque',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/gen/posicaoEstoqueListagem')
    },
    {
        path: "/sde/estoque/ajuste",
        name: 'estoqueAjuste',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE],
        },
        component: () => import('@/views/sde/estoque/estoqueAjuste')
    },

    // DASHBOARDS
    {
        path: "/sde",
        name: 'sdeDashboard',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SDE_ADMIN, LISTA_PERMISSOES.SDE_MEDICO, LISTA_PERMISSOES.SDE_SECRETARIO, LISTA_PERMISSOES.SDE_FARMACEUTICO, LISTA_PERMISSOES.SDE_ALMOXARIFE, LISTA_PERMISSOES.SDE_ENFERMEIRO],
        },
        component: () => import('@/views/sde/dashBoard')
    },
]
